import { __exports as n } from "../../../../_virtual/ariaAppHider.js";
import { w as m } from "../../../warning/warning.js";
import "./safeHTMLElement.js";
import { __exports as c } from "../../../../_virtual/safeHTMLElement.js";
Object.defineProperty(n, "__esModule", {
  value: !0
});
n.resetState = h;
n.log = A;
n.assertNodeList = f;
n.setElement = g;
n.validateElement = s;
n.hide = _;
n.show = w;
n.documentNotReadyOrSSRTesting = N;
var v = m, p = E(v), y = c;
function E(e) {
  return e && e.__esModule ? e : { default: e };
}
var t = null;
function h() {
  t && (t.removeAttribute ? t.removeAttribute("aria-hidden") : t.length != null ? t.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(t).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), t = null;
}
function A() {
  if (process.env.NODE_ENV !== "production") {
    var e = t || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function f(e, r) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + r + ".");
}
function g(e) {
  var r = e;
  if (typeof r == "string" && y.canUseDOM) {
    var o = document.querySelectorAll(r);
    f(o, r), r = o;
  }
  return t = r || t, t;
}
function s(e) {
  var r = e || t;
  return r ? Array.isArray(r) || r instanceof HTMLCollection || r instanceof NodeList ? r : [r] : ((0, p.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function _(e) {
  var r = !0, o = !1, i = void 0;
  try {
    for (var a = s(e)[Symbol.iterator](), l; !(r = (l = a.next()).done); r = !0) {
      var u = l.value;
      u.setAttribute("aria-hidden", "true");
    }
  } catch (d) {
    o = !0, i = d;
  } finally {
    try {
      !r && a.return && a.return();
    } finally {
      if (o)
        throw i;
    }
  }
}
function w(e) {
  var r = !0, o = !1, i = void 0;
  try {
    for (var a = s(e)[Symbol.iterator](), l; !(r = (l = a.next()).done); r = !0) {
      var u = l.value;
      u.removeAttribute("aria-hidden");
    }
  } catch (d) {
    o = !0, i = d;
  } finally {
    try {
      !r && a.return && a.return();
    } finally {
      if (o)
        throw i;
    }
  }
}
function N() {
  t = null;
}
export {
  n as default
};
